module.exports = __webpack_public_path__ + "static/img/swipe3.27e12487.png";